import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentView } from '../../models/component-view.model';
import { MainAppService } from '../../services/main-app.service';
import { AppMainComponent } from '../app-main/app-main.component';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageNotFoundComponent extends ComponentView {

    router = inject(Router);

    // Führt die Rücksprungadresse nach dem Login ins Leere, geht es ohne Hinweis direkt zur Startseite
    redirecting = this.router.currentNavigation()?.extras.state?.[MainAppService.navigationStateFromLogin] === true;

    async initParams(): Promise<boolean> {
        if (this.redirecting) {
            await this.app.navigateToComponent(AppMainComponent, {}, true);
            return false;
        }
        return true;
    }

    async goHome(): Promise<void> {
        await this.app.navigateToComponent(AppMainComponent, {});
    }
}
